import React from 'react';

import Grid from '../../atoms/Grid';
import { StringOrNull } from '../../../types';
import { getJapaneseDateTimeAsString } from '../../../utils/MomentUtil';
import { setStringToBrackets } from '../../../utils/StringUtil';

export interface ReceptionContentsTableProps {
  dataType: 'ginie' | 'bsw';
  acceptedDateTime: StringOrNull;
  registrationCrewCode: StringOrNull;
  registrationCrewName: StringOrNull;
  customerCrewCode: StringOrNull;
  customerCrewName: StringOrNull;
}

const ReceptionContentsTable: React.FC<ReceptionContentsTableProps> = ({
  dataType,
  acceptedDateTime,
  registrationCrewCode,
  registrationCrewName,
  customerCrewCode,
  customerCrewName,
}) => {
  const hyphens = '----------';
  return (
    <>
      <Grid.Col colS={12} colM={12} colL={12} className='u-mb8'>
        <span
          className='u-text-secondary u-text-bold'
          data-testid={`${dataType}-accepted-datetime-label`}
          data-testid-e2e={`${dataType}-accepted-datetime-label`}>
          受付日時
        </span>
        <p
          className='report-cards__item-title'
          data-testid={`${dataType}-accepted-datetime-value`}
          data-testid-e2e={`${dataType}-accepted-datetime-value`}>
          {acceptedDateTime && getJapaneseDateTimeAsString(acceptedDateTime)}
        </p>
      </Grid.Col>
      <Grid.Col colS={12} colM={12} colL={12} className='u-mb8'>
        <span
          className='u-text-secondary u-text-bold'
          data-testid={`${dataType}-registration-crew-code-label`}
          data-testid-e2e={`${dataType}-registration-crew-code-label`}>
          受付担当者
        </span>
        <p
          className='report-cards__item-title'
          data-testid={`${dataType}-registration-crew-code-value`}
          data-testid-e2e={`${dataType}-registration-crew-code-value`}>
          {registrationCrewCode && `${registrationCrewName || hyphens}${setStringToBrackets(registrationCrewCode)}`}
        </p>
      </Grid.Col>
      <Grid.Col colS={12} colM={12} colL={12} className='u-mb8'>
        <span
          className='u-text-secondary u-text-bold'
          data-testid={`${dataType}-customer-crew-name-label`}
          data-testid-e2e={`${dataType}-customer-crew-name-label`}>
          接客担当者
        </span>
        <p
          className='report-cards__item-title'
          data-testid={`${dataType}-customer-crew-name-value`}
          data-testid-e2e={`${dataType}-customer-crew-name-value`}>
          {customerCrewCode && `${customerCrewName || hyphens}${setStringToBrackets(customerCrewCode)}`}
        </p>
      </Grid.Col>
    </>
  );
};

export default ReceptionContentsTable;
